<template>
  <div>
    <div class="mrB20" />
    <div class="comm_view_wrap">
      <div class="row">
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_CARD_UID')"
          />
        </div>
        <div class="col-xs-5 ">
          <sui-text-field
            ref="textFieldCardUid"
            v-model="objCard.cardUid"
            maxlength="40"
            :readonly="true"
          />
        </div>
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_CARD_NM')"
            :required="true"
          />
        </div>
        <div class="col-xs-5 ">
          <sui-text-field
            ref="textFieldCardName"
            v-model="objCard.cardName"
            maxlength="100"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1 ">
          <sui-input-label
            :label="$t('MSG_TXT_CARD_TYPE')"
          />
        </div>
        <div class="col-xs-5 ">
          <sui-code-select
            ref="codeSelectCardTypeCode"
            v-model="objCard.cardTypeCode"
            codeId="COD_CARD_TYPE"
          />
        </div>
        <div class="col-xs-1 nodata"/>
        <div class="col-xs-5 nodata"/>
      </div>
    </div>
    <vue-json-editor
      ref="jsonEditorCardMeta"
      v-model="cardMetaJson"
      :expandedOnStart="true"
      @json-change="onJsonChange">
    </vue-json-editor>
    <div class="mrB30" />
    <div class="comm_btn_wrap">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickMapping"
      >
        {{ $t("MSG_TIT_CARD_PAGE_MAP") }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClickNew"
      >
        {{ $t("MSG_BTN_NEW") }}
      </sui-button>
      <sui-button
        v-permission:delete="contextPageId"
        type="button"
        class="comm_btn_border"
        @click="onClickDelete"
      >
        {{ $t("MSG_BTN_DEL") }}
      </sui-button>
      <sui-button
        v-permission:create="contextPageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t("MSG_BTN_SAVE") }}
      </sui-button>  
    </div>
  </div>
</template>

<script>
import BasePage from '~cm/components/BasePage';
import vueJsonEditor from 'vue-json-editor';

export default {
  name: 'PGE_CMX_00008_T01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  components: { vueJsonEditor },
  props: {
    selectedGridRowData: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      isNew : true,
      objCard: {
        cardUid: '',
        cardName: '',
        cardTypeCode: '',
        cardTypeCodeName: '',
        cardMeta: '',
        finalModificationUserId: '',
        finalModificationDTM: '',
      },
      cardMetaJson: {},
    };
  },
  computed: {},
  watch: {
    selectedGridRowData(selectObj) {
      if (selectObj) {
        this.loadCard();
      } else {
        this.onClickNew();
      }
    },
  },
  created() {
    this.customOptions = {
    };
    this.initialJson = {
      title: '',
      labels: [],
      datasets: [
        {
          alias: 0,
          label: '',
          fill: true,
          backgroundColor: [],
          borderColor: [],
          data: [],
        }
      ],
    };
  },  
  mounted() {
    this.cardMetaJson = this.initialJson;
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    loadCard() {
      if(this.selectedGridRowData) {
        const cardUid = this.selectedGridRowData.cardUid;
        if(  !utils.isEmpty(cardUid)) {
          http.requestTest('get', `/api/v1/o9/card/${cardUid}`, {
          //http.request(this.contextPageId, 'DTS_XXX_XXXXX', {  
            path: {
              'card-uid': cardUid,
            },
          }).then(res => {
            this.objCard = res.data;
            this.cardMetaJson = JSON.parse(this.objCard.cardMeta);
            this.isNew = false;
          });
        }
      }
    },  
    onClickNew() {
      this.objCard.cardUid = '';
      this.objCard.cardName = '';
      this.$refs.codeSelectCardTypeCode.reset();
      this.objCard.cardTypeCodeName = '';
      this.objCard.cardMeta = '';    
      this.cardMetaJson = this.initialJson;

      this.isNew = true;
    },
    onClickDelete() {
      
      const cardUid = this.objCard.cardUid;    
      if(  !utils.isEmpty(cardUid)) {
        utils.messageBox('confirm', this.$t('MSG_ALT_WANT_DEL'), null, () => {
          http.requestTest('delete', `/api/v1/o9/card/${cardUid}`, {
          // http.request(this.contextPageId, 'DTS_XXX_XXXXX', {
            path: {
              'card-uid': cardUid,
            },
          }).then(() => {
            utils.messageBox('success', this.$t('MSG_ALT_DELETED'));
            this.$emit('onClickSearch');
            this.onClickNew();
          });
        });
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
    onClickSave() {
      
      if (utils.isEmpty(this.objCard.cardName)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_CARD_NM')), null, () => {
          this.$refs.textFieldCardName.setFocus();
        });
        return false;
      }

      this.objCard.cardMeta = JSON.stringify(this.cardMetaJson);
      
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        // sonarcube codesmell 대응
        // const dataServiceId = this.isNew ? 'DTS_XXX_XXXXX' : 'DTS_XXX_XXXXX';
        const dataServiceId = 'DTS_XXX_XXXXX';
        http.requestTest((this.isNew ? 'post' : 'put'), '/api/v1/o9/card', {
          // http.request(this.contextPageId, dataServiceId, {
          data: this.objCard,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.$emit('onClickSearch');
          this.onClickNew();
        });
      });
    },
    onJsonChange(value) {
    },
    onClickMapping() {
      utils.openLayerPopup('PGE_CMX_00009',
        this.onClosePagePopup,
        {
          pageInitialData: {
            pageId: 'PGE_CMX_00006',
          },
          size: 'xlg',
        }
      );
    },
  },
};
</script>

<style scoped>
</style>
